/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { useEffect, useState } from "react";

interface DelayProps {
    wait?: number;
    children: JSX.Element;
}

const Delay = ({ wait = 250, children }: DelayProps) => {
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsShown(true);
        }, wait);

        return () => {
            clearTimeout(timer);
        };
    }, [wait]);

    return isShown ? children : null;
};

export default Delay;
